module.exports = __webpack_public_path__ + "img/search_gray.fad37ef9.png";